// src/components/cta/FinalCta.tsx
import React from 'react';
import { motion } from 'framer-motion';
import {Button} from '@dopomogai/ui';
import { ArrowRight } from 'lucide-react';

interface FinalCtaData {
  headline: string;
  text: string;
  button1: string;
  button2?: string; // <--- CHANGED: Made this prop optional
  button3?: string;
}

interface ActionConfig {
  action: string;
  payload?: any;
}

interface FinalCtaProps {
  finalCtaData: FinalCtaData;
  onAction: (actionType: string, payload?: any) => void;
  buttonActions: {
    button1: ActionConfig;
    button2?: ActionConfig; // <--- CHANGED: Made this prop optional
    button3?: ActionConfig;
  };
}

export const FinalCta: React.FC<FinalCtaProps> = ({ finalCtaData, onAction, buttonActions }) => {
  return (
    <section className="bg-gray-900 text-white py-20 md:py-24">
      <div className="container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.25, 1, 0.5, 1] }}
        >
          <h2 className="text-3xl md:text-4xl font-bold leading-tight">
            {finalCtaData.headline}
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-slate-300 text-lg">
            {finalCtaData.text}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            {finalCtaData.button1 && buttonActions.button1 && (
              <Button
                text={finalCtaData.button1}
                variant="primary"
                size="lg"
                onClick={() => onAction(buttonActions.button1.action, buttonActions.button1.payload)}
                className="w-full sm:w-auto hover:shadow-[4px_4px_0_0_#10b981]"
              />
            )}
            {/* This logic already correctly checks if button2 data and actions exist before rendering */}
            {finalCtaData.button2 && buttonActions.button2 && (
              <Button
                text={finalCtaData.button2}
                variant="secondary"
                size="lg"
                onClick={() => onAction(buttonActions.button2!.action, buttonActions.button2!.payload)}
                icon={<ArrowRight size={18} />}
                iconPosition="right"
                className="w-full sm:w-auto bg-slate-700 text-white hover:bg-slate-600 hover:shadow-[4px_4px_0_0_#9ca3af]"
              />
            )}
          </div>

          {finalCtaData.button3 && buttonActions.button3 && (
             <div className="mt-8">
                <Button
                  text={finalCtaData.button3}
                  variant="ghost"
                  size="md"
                  onClick={() => buttonActions.button3 && onAction(buttonActions.button3.action, buttonActions.button3.payload)}
                  className="text-slate-400 hover:text-white hover:bg-white/10 hover:shadow-[4px_4px_0_0_#475569]"
                />
             </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};